import React, { useState, useRef } from 'react';
import { FaArrowsAltH } from 'react-icons/fa';
import { FaBoxOpen, FaCarSide, FaPaw, FaUserAlt, FaPaintBrush } from 'react-icons/fa';
import shoesR from './images/shoesR.png';
import shoesNotR from './images/shoesnotR.jpg';
import premove from './images/peopleremove.png';
import poriginal from './images/peopleorignatl.jpg';
import animal0 from './images/animalo.avif';
import animalR from './images/animalr.png';
import caro from './images/caro.jpg';
import carr from './images/carr.png';
import dummyo from './images/1.png';
import dummyr from './images/2.png';


const tabData = {
    Products: { icon: FaBoxOpen, original: shoesNotR, removed: shoesR },
    People: { icon: FaUserAlt, original: poriginal, removed: premove },
    Animals: { icon: FaPaw, original: animal0, removed: animalR },
    Cars: { icon: FaCarSide, original: caro, removed: carr },
    Graphics: { icon: FaPaintBrush, original: dummyo, removed: dummyr },
};
const tabs = Object.keys(tabData);

export default function BeforeAfterSlider() {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [activeTab, setActiveTab] = useState('Products');
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const updateSlider = (clientX: number) => {
    const bounds = containerRef.current?.getBoundingClientRect();
    if (!bounds) return;
    const pos = ((clientX - bounds.left) / bounds.width) * 100;
    setSliderPosition(Math.min(100, Math.max(0, pos)));
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (isDragging) {
      updateSlider(e.clientX);
    }
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (isDragging) {
      updateSlider(e.touches[0].clientX);
    }
  };

  const handleMouseUp = () => setIsDragging(false);
  const handleTouchEnd = () => setIsDragging(false);

  const { icon: Icon, original, removed } = tabData[activeTab];

  const transparentBg = `url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAGUExURb+/v////5nD/3QAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAUSURBVBjTYwABQSCglEENMxgYGAAynwRB8BEAgQAAAABJRU5ErkJggg==")`;

  return (
    <section className="mx-auto w-full px-8 max-w-5xl text-center mt-10">

      {/* Header */}
      <div className="flex flex-col justify-center items-center text-center">
        <h1 className="text-3xl md:text-5xl text-left md:text-center font-poppins font-extrabold text-[#242424] mb-4">
          Remove backgrounds from any photo category and download professional results instantly.
        </h1>
        <p className="mb-10 text-[#242424] text-sm md:text-lg text-left md:text-center font-medium font-poppins">
          Create designs with our background remover tool. Turn your images into art, stunning banners,
          visual presentations, product catalog and graphics—fully customizable for your needs.
        </p>
      </div>
      

      {/* Tabs */}
      <div className="flex justify-center font-poppins flex-wrap gap-2 mb-10">
        {tabs.map((tab) => {
          const TabIcon = tabData[tab].icon;
          const isActive = activeTab === tab;
          return (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`flex items-center gap-1 z-10 font-poppins px-4 py-2 text-sm font-medium rounded-full transition ${
                isActive ? 'bg-[#191A1F] text-white' : 'bg-gray-100 hover:bg-gray-200'
              }`}
            >
              <TabIcon className={isActive ? 'text-white mr-1' : 'text-gray-600 mr-1'} />
              {tab}
            </button>
          );
        })}
      </div>

      {/* Image Slider */}
      <div
        ref={containerRef}
        className="relative mx-auto max-w-6xl aspect-video rounded-xl overflow-hidden group cursor-ew-resize select-none"
        onMouseMove={handleMouseMove}
        onTouchMove={handleTouchMove}
        onMouseUp={handleMouseUp}
        onTouchEnd={handleTouchEnd}
        onMouseLeave={handleMouseUp}
      >
        {/* Background Removed Image (Right side) */}
        <img
          src={removed}
          alt="After"
          className="w-full h-full object-cover absolute top-0 left-0"
          style={{ background: transparentBg, backgroundRepeat: 'repeat' }}
        />

        {/* Original Image (Left side) */}
        <img
          src={original}
          alt="Before"
          className="w-full h-full object-cover absolute top-0 left-0"
          style={{
            clipPath: `polygon(0 0, ${sliderPosition}% 0, ${sliderPosition}% 100%, 0 100%)`,
            transition: 'clip-path 0.1s ease-out',
          }}
        />

        {/* White Divider Line */}
        <div
          className="absolute top-0 bottom-0 w-[2px] bg-white z-10"
          style={{ left: `calc(${sliderPosition}% - 1px)` }}
        />

        {/* Drag Handle */}
        <div
          className="absolute top-1/2 -translate-y-1/2 z-20 h-[34px] w-8 bg-white border border-gray-300 rounded-full shadow-md flex items-center justify-center transition-transform duration-300 hover:scale-110 cursor-pointer"
          style={{ left: `calc(${sliderPosition}% - 16px)` }}
          onMouseDown={(e) => {
            e.preventDefault();      // prevent text/image selection
            setIsDragging(true);
          }}
          onTouchStart={(e) => {
            e.preventDefault();      // prevent mobile long-press selection
            setIsDragging(true);
          }}
        >
          <FaArrowsAltH className="text-gray-700" />
        </div>
      </div>
    </section>
  );
}